(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buy-cta"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var rIC = window.requestIdleCallback
      ? function(cb) { requestIdleCallback(cb, { timeout: 200 }); }
      : function(cb) { setTimeout(cb, 0); };

    rIC(function() {
      document.addEventListener('change', function(e) {
        if (!e.target.matches('.cta-bundle-card__radio')) return;
        var selectedCard = e.target.closest('.cta-bundle-card');
        document.querySelectorAll('.cta-bundle-card').forEach(function(card) {
          card.classList.toggle('cta-bundle-card--active', card === selectedCard);
        });
        var variantInput = document.getElementById('CtaVariantId');
        if (variantInput) variantInput.value = e.target.value;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var rIC = window.requestIdleCallback
      ? function(cb) { requestIdleCallback(cb, { timeout: 200 }); }
      : function(cb) { setTimeout(cb, 0); };

    rIC(function() {
      var cartForm = document.getElementById('cart-form');
      if (!cartForm) return;

      var currency = cartForm.dataset.currency || 'EUR';
      var formatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency });

      function formatMoney(cents) {
        return formatter.format(cents / 100);
      }

      cartForm.addEventListener('click', function(e) {
        var btn = e.target.closest('.cart-item__quantity-btn');
        if (!btn) return;

        var delta = parseInt(btn.dataset.delta, 10);
        var input = btn.parentElement.querySelector('.cart-item__quantity-input');
        var newVal = Math.max(0, parseInt(input.value, 10) + delta);
        input.value = newVal;
        var line = parseInt(input.dataset.line, 10);
        var btns = btn.parentElement.querySelectorAll('.cart-item__quantity-btn');
        btns.forEach(function(b) { b.disabled = true; });

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: newVal })
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (newVal === 0) { window.location.reload(); return; }
          requestAnimationFrame(function() {
            var lineItem = cart.items[line - 1];
            var lineTotal = document.getElementById('cart-line-total-' + line);
            if (lineTotal && lineItem) lineTotal.textContent = formatMoney(lineItem.final_line_price);
            var subtotal = document.getElementById('CartSubtotal');
            if (subtotal) subtotal.textContent = formatMoney(cart.original_total_price);
            var total = document.getElementById('CartTotal');
            if (total) total.textContent = formatMoney(cart.total_price);
            btns.forEach(function(b) { b.disabled = false; });
          });
        })
        .catch(function() { window.location.reload(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var rIC = window.requestIdleCallback
      ? function(cb) { requestIdleCallback(cb, { timeout: 200 }); }
      : function(cb) { setTimeout(cb, 0); };

    function swapProductImage(src) {
      var mainImg = document.getElementById('ProductMainImage');
      if (!mainImg) return;
      mainImg.style.opacity = '0';
      setTimeout(function() {
        requestAnimationFrame(function() {
          mainImg.srcset = '';
          mainImg.src = src;
          mainImg.style.opacity = '1';
        });
      }, 150);
    }

    rIC(function() {
      document.addEventListener('click', function(e) {
        var thumb = e.target.closest('.product-gallery__thumb');
        if (thumb) {
          swapProductImage(thumb.dataset.src);
          document.querySelectorAll('.product-gallery__thumb').forEach(function(t) {
            t.classList.toggle('product-gallery__thumb--active', t === thumb);
          });
          return;
        }
        var qtyBtn = e.target.closest('#product-form .qty-btn');
        if (qtyBtn) {
          var input = document.getElementById('ProductQty');
          var hidden = document.getElementById('ProductQtyHidden');
          var val = parseInt(input.value, 10) || 1;
          if (qtyBtn.dataset.action === 'plus') val++;
          else if (qtyBtn.dataset.action === 'minus' && val > 1) val--;
          input.value = val;
          if (hidden) hidden.value = val;
        }
      });

      var variantSelect = document.getElementById('ProductVariantSelect');
      if (variantSelect) {
        var variantDataEl = document.getElementById('ProductVariantData');
        var variants = [];
        try { variants = JSON.parse(variantDataEl ? variantDataEl.textContent : '[]'); } catch(e) {}

        variantSelect.addEventListener('change', function() {
          var selectedId = parseInt(this.value, 10);
          var variant = null;
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].id === selectedId) { variant = variants[i]; break; }
          }
          if (!variant) return;

          var hiddenId = document.getElementById('ProductVariantId');
          if (hiddenId) hiddenId.value = selectedId;

          if (variant.image) swapProductImage(variant.image);

          requestAnimationFrame(function() {
            var priceBox = document.getElementById('ProductPrice');
            if (priceBox) {
              if (variant.hasCompare) {
                priceBox.innerHTML =
                  '<span class="product-price product-price--sale">' + variant.priceFormatted + '</span>' +
                  '<span class="product-price product-price--compare">' + variant.compareAtPriceFormatted + '</span>' +
                  '<span class="product-price__badge">-' + variant.discount + '%</span>';
              } else {
                priceBox.innerHTML = '<span class="product-price">' + variant.priceFormatted + '</span>';
              }
            }
            var addBtn = document.getElementById('ProductAddBtn');
            if (addBtn) {
              addBtn.disabled = !variant.available;
              addBtn.textContent = variant.available
                ? addBtn.dataset.textAvailable
                : addBtn.dataset.textSoldout;
            }
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var rIC = window.requestIdleCallback
      ? function(cb) { requestIdleCallback(cb, { timeout: 200 }); }
      : function(cb) { setTimeout(cb, 0); };

    rIC(function() {
      document.querySelectorAll('.slideshow').forEach(function(sw) {
        var slides = sw.querySelectorAll('.slideshow__slide');
        var dots = sw.querySelectorAll('.slideshow__dot');
        var current = 0;
        var autoplay = sw.dataset.autoplay === 'true';
        var speed = parseInt(sw.dataset.speed, 10) * 1000 || 5000;
        var timer;

        function goTo(n) {
          slides[current].classList.remove('slideshow__slide--active');
          if (dots[current]) dots[current].classList.remove('slideshow__dot--active');
          current = (n + slides.length) % slides.length;
          slides[current].classList.add('slideshow__slide--active');
          if (dots[current]) dots[current].classList.add('slideshow__dot--active');
        }

        function resetTimer() {
          clearInterval(timer);
          if (autoplay) timer = setInterval(function() { goTo(current + 1); }, speed);
        }

        sw.addEventListener('click', function(e) {
          var btn = e.target.closest('.slideshow__btn--prev, .slideshow__btn--next, .slideshow__dot');
          if (!btn) return;
          if (btn.classList.contains('slideshow__btn--prev')) { goTo(current - 1); resetTimer(); }
          else if (btn.classList.contains('slideshow__btn--next')) { goTo(current + 1); resetTimer(); }
          else {
            var i = Array.prototype.indexOf.call(dots, btn);
            if (i > -1) { goTo(i); resetTimer(); }
          }
        });

        if (autoplay) timer = setInterval(function() { goTo(current + 1); }, speed);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urgency-banner"]) return;
  try {
    
  (function() {
    var rIC = window.requestIdleCallback
      ? function(cb) { requestIdleCallback(cb, { timeout: 200 }); }
      : function(cb) { setTimeout(cb, 0); };

    rIC(function() {
      var el = document.getElementById('urgency-countdown');
      if (!el) return;

      var hours = parseInt(el.dataset.hours, 10) || 12;
      var DURATION = hours * 3600 * 1000;
      var KEY = 'sg_offer_end';

      var stored = parseInt(localStorage.getItem(KEY), 10);
      var end = (stored && stored > Date.now()) ? stored : Date.now() + DURATION;
      if (!stored || stored <= Date.now()) localStorage.setItem(KEY, end);

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          end = Date.now() + DURATION;
          localStorage.setItem(KEY, end);
          diff = DURATION;
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }

      tick();
      setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-highlights"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var rIC = window.requestIdleCallback
      ? function(cb) { requestIdleCallback(cb, { timeout: 200 }); }
      : function(cb) { setTimeout(cb, 0); };

    rIC(function() {
      document.addEventListener('click', function(e) {
        var player = e.target.closest('.video-highlights__player');
        if (player) {
          if (player.querySelector('iframe')) return;
          var videoUrl = player.dataset.video;
          if (!videoUrl) return;
          var isYoutube = videoUrl.indexOf('youtube') > -1 || videoUrl.indexOf('youtu.be') > -1;
          var isVimeo = videoUrl.indexOf('vimeo') > -1;
          var embedUrl = '';
          if (isYoutube) {
            var videoId = videoUrl.split('v=')[1] || videoUrl.split('/').pop();
            videoId = videoId.split('&')[0].split('?')[0];
            embedUrl = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0';
          } else if (isVimeo) {
            var vId = videoUrl.split('/').pop();
            embedUrl = 'https://player.vimeo.com/video/' + vId + '?autoplay=1';
          }
          if (!embedUrl) return;
          var iframe = document.createElement('iframe');
          iframe.src = embedUrl;
          iframe.allow = 'autoplay; encrypted-media; fullscreen';
          iframe.allowFullscreen = true;
          iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;';
          player.innerHTML = '';
          player.appendChild(iframe);
          return;
        }

        var scrollBtn = e.target.closest('[id^="VHPrev-"], [id^="VHNext-"]');
        if (scrollBtn) {
          var isPrev = scrollBtn.id.indexOf('VHPrev-') === 0;
          var trackId = scrollBtn.id.replace(isPrev ? 'VHPrev-' : 'VHNext-', '');
          var track = document.getElementById('VHTrack-' + trackId);
          if (track) track.scrollBy({ left: isPrev ? -300 : 300, behavior: 'smooth' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var rIC = window.requestIdleCallback
      ? function(cb) { requestIdleCallback(cb, { timeout: 200 }); }
      : function(cb) { setTimeout(cb, 0); };

    rIC(function() {
      document.addEventListener('click', function(e) {
        var cover = e.target.closest('.video-section__cover');
        if (!cover) return;
        var player = cover.closest('.video-section__player');
        var embed = player && player.querySelector('.video-section__embed');
        if (!embed) return;
        cover.style.display = 'none';
        embed.style.display = 'block';
        var iframe = document.createElement('iframe');
        iframe.className = 'video-section__iframe';
        iframe.allow = 'autoplay; encrypted-media; fullscreen';
        iframe.allowFullscreen = true;
        iframe.src = embed.dataset.embedSrc || '';
        embed.appendChild(iframe);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
